import { useState } from "react";

const G = `
@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;1,300&family=DM+Sans:wght@300;400;500;600;700&display=swap');
*,*::before,*::after{box-sizing:border-box;margin:0;padding:0;}
body{font-family:'DM Sans',sans-serif;background:#0F0F0F;color:#0F0F0F;-webkit-font-smoothing:antialiased;}
button{font-family:'DM Sans',sans-serif;cursor:pointer;}
@keyframes fadeUp{from{opacity:0;transform:translateY(14px);}to{opacity:1;transform:translateY(0);}}
@keyframes fadeIn{from{opacity:0;}to{opacity:1;}}
@keyframes pulse{0%,100%{opacity:1;}50%{opacity:0.35;}}
@keyframes pop{0%{transform:scale(0.94);opacity:0;}70%{transform:scale(1.03);}100%{transform:scale(1);opacity:1;}}
@keyframes checkIn{0%{transform:scale(0);}65%{transform:scale(1.2);}100%{transform:scale(1);}}
`;

const C={
  black:"#0F0F0F",white:"#FFFFFF",
  beige:"#F5F0E8",beigeDeep:"#EDE5D5",
  gold:"#C9922A",goldSoft:"#FDF3E3",goldLight:"#E8B84B",
  purple:"#7C3AED",purpleSoft:"#EDE9FE",
  green:"#1A7A3C",greenSoft:"#EBF7EF",
  blue:"#1A4ED8",blueSoft:"#EBF0FD",
  teal:"#0E7490",tealSoft:"#E0F7FA",
  sep:"#E2D9C8",muted:"#7A6F5E",text:"#0F0F0F",
};

const SCREENS = {
  home: "Home",
  concept: "Concept Room",
  board: "Phase Board",
  client: "Client File",
};

const PHASES = [
  {num:1,label:"Concept & Layout",icon:"✦",done:true,color:"#C9922A"},
  {num:2,label:"Tile",icon:"⬡",done:true,color:"#1A4ED8"},
  {num:3,label:"Plumbing Fixtures",icon:"🚿",done:true,color:"#0E7490"},
  {num:4,label:"Vanity & Cabinetry",icon:"🪵",done:true,color:"#B45309"},
  {num:5,label:"Stone & Countertops",icon:"◈",done:false,color:"#6B21A8"},
  {num:6,label:"Lighting",icon:"💡",done:false,color:"#1A7A3C"},
  {num:7,label:"Finishing Touches",icon:"✿",done:false,color:"#9D174D"},
];

const SECTIONS = [
  {label:"Shower Wall Tile",status:"done",note:"Remedy Misty Blue · Vertical Stack"},
  {label:"Bathroom Floor",status:"done",note:"Concept Gray 12×24 · Stack Bond"},
  {label:"Shower Floor",status:"done",note:"Concept Gray 2×2 Mosaic"},
  {label:"Vanity Countertop",status:"review",note:"Vadara Sinterra — PENDING template"},
  {label:"Shower Glass",status:"blocked",note:"Duarte at template — awaiting"},
  {label:"Vanity Lighting",status:"review",note:"Sconce style TBD"},
  {label:"Grout & Sealers",status:"empty",note:""},
  {label:"Paint",status:"done",note:"Accessible Beige SW7036"},
];

const STATUS_COLOR = {done:C.green,review:"#B45309",blocked:"#C0170F",empty:C.muted};
const STATUS_BG = {done:C.greenSoft,review:"#FEF3C7",blocked:"#FDECEB",empty:C.beige};
const STATUS_LABEL = {done:"Done",review:"Review",blocked:"Blocked",empty:"Empty"};

const MILESTONES = [
  {l:"Contract Signed",d:"Oct 28, 2025",done:true},
  {l:"Permit Approved",d:"Dec 20, 2025",done:true},
  {l:"Demo Complete",d:"Jan 15, 2026",done:true},
  {l:"Rough In Inspected",d:"Feb 14, 2026",done:true},
  {l:"Tile Complete",d:"Mar 10, 2026",done:true},
  {l:"Stone Template Day",d:"Apr 4, 2026",done:false},
  {l:"Stone Installed",d:"Apr 18, 2026",done:false},
  {l:"Final Walkthrough",d:"May 22, 2026",done:false},
  {l:"Project Complete",d:"May 30, 2026",done:false},
];

const CHECKS = [
  "Demo complete — photos taken","Rough plumbing inspected",
  "Rough electrical inspected","Drywall complete",
  "Tile complete","Stone template done",
];

function Ring({pct,size=100,stroke=7,color="#C9922A"}){
  const r=(size-stroke*2)/2,circ=2*Math.PI*r,off=circ-(pct/100)*circ;
  return(
    <div style={{position:"relative",width:size,height:size,flexShrink:0}}>
      <svg width={size} height={size} style={{transform:"rotate(-90deg)"}}>
        <circle cx={size/2} cy={size/2} r={r} fill="none" stroke="rgba(255,255,255,0.08)" strokeWidth={stroke}/>
        <circle cx={size/2} cy={size/2} r={r} fill="none" stroke={color} strokeWidth={stroke}
          strokeDasharray={circ} strokeDashoffset={off} strokeLinecap="round"/>
      </svg>
      <div style={{position:"absolute",inset:0,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
        <span style={{fontSize:size*0.22,fontWeight:700,color:"#F5EDD8",lineHeight:1}}>{pct}%</span>
        <span style={{fontSize:size*0.1,color:"#6B5A3A"}}>done</span>
      </div>
    </div>
  );
}

export default function App(){
  const [screen,setScreen]=useState("home");
  const [checks,setChecks]=useState({});
  const [completedSections,setCompleted]=useState({
    "Shower Wall Tile":true,"Bathroom Floor":true,"Shower Floor":true,"Paint":true
  });
  const [activeSection,setActiveSection]=useState(null);
  const [justDone,setJustDone]=useState(null);

  const doneSections = SECTIONS.filter(s=>completedSections[s.label]||s.status==="done").length;
  const pct = Math.round(doneSections/SECTIONS.length*100);

  const markDone = (label) => {
    setCompleted(p=>({...p,[label]:true}));
    setJustDone(label);
    setActiveSection(null);
    setTimeout(()=>setJustDone(null),2500);
  };

  return(
    <div style={{minHeight:"100vh",display:"flex",flexDirection:"column",background:"#0F0F0F"}}>
      <style>{G}</style>

      {/* Achievement toast */}
      {justDone&&(
        <div style={{position:"fixed",top:20,left:"50%",transform:"translateX(-50%)",background:"linear-gradient(135deg,#1A7A3C,#0D5C2A)",borderRadius:60,padding:"12px 24px",zIndex:999,display:"flex",alignItems:"center",gap:10,boxShadow:"0 6px 24px rgba(26,122,60,0.5)",animation:"pop 0.4s ease",whiteSpace:"nowrap"}}>
          <span style={{fontSize:18,animation:"checkIn 0.4s ease"}}>✓</span>
          <p style={{fontSize:14,fontWeight:700,color:"#FFF"}}>{justDone} — complete</p>
        </div>
      )}

      {/* Top bar */}
      <div style={{background:"#0A0A0A",borderBottom:"1px solid #1A1A1A",height:52,display:"flex",alignItems:"center",justifyContent:"space-between",padding:"0 28px",flexShrink:0,position:"sticky",top:0,zIndex:100}}>
        <div style={{display:"flex",alignItems:"center",gap:8,cursor:"pointer"}} onClick={()=>setScreen("home")}>
          <span style={{fontSize:18,color:C.gold}}>◈</span>
          <span style={{fontSize:11,fontWeight:700,letterSpacing:"0.18em",color:C.gold,textTransform:"uppercase"}}>Elite Hub</span>
        </div>
        {screen!=="home"&&(
          <div style={{display:"flex",alignItems:"center",gap:4}}>
            <span style={{fontSize:11,color:"#333"}}>›</span>
            <span style={{fontSize:11,color:"#555"}}>{SCREENS[screen]}</span>
          </div>
        )}
        <div style={{display:"flex",alignItems:"center",gap:8}}>
          <div style={{width:7,height:7,borderRadius:"50%",background:C.green,animation:"pulse 2s infinite"}}/>
          <span style={{fontSize:12,color:"#444"}}>Grace</span>
          <div style={{width:28,height:28,borderRadius:"50%",background:C.purple,display:"flex",alignItems:"center",justifyContent:"center",fontSize:12,fontWeight:700,color:"#FFF"}}>S</div>
        </div>
      </div>

      {/* ── HOME ── */}
      {screen==="home"&&(
        <div style={{flex:1,overflow:"auto"}}>
          {/* Hero */}
          <div style={{background:"linear-gradient(180deg,#1A1100,#111)",padding:"36px 32px 28px"}}>
            <div style={{maxWidth:860,margin:"0 auto",display:"flex",gap:28,alignItems:"center"}}>
              <Ring pct={pct} size={100} stroke={7} color={C.gold}/>
              <div style={{flex:1}}>
                <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:8}}>
                  <div style={{width:7,height:7,borderRadius:"50%",background:C.green,animation:"pulse 2s infinite"}}/>
                  <span style={{fontSize:10,fontWeight:700,letterSpacing:"0.14em",color:"rgba(52,199,89,0.8)",textTransform:"uppercase"}}>Active Project</span>
                </div>
                <h1 style={{fontFamily:"'Cormorant Garamond',serif",fontSize:36,fontWeight:300,color:"#F5EDD8",lineHeight:1.1,marginBottom:4}}>1055 Roble Ln</h1>
                <p style={{fontSize:14,color:"#6B5A3A",marginBottom:14}}>Primary Bath  ·  Ray Hahn & Will Long  ·  Modern Organic</p>
                <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                  <span style={{padding:"4px 12px",background:"rgba(201,146,42,0.15)",borderRadius:50,fontSize:12,fontWeight:600,color:C.gold}}>{doneSections}/{SECTIONS.length} sections</span>
                  <span style={{padding:"4px 12px",background:"rgba(26,122,60,0.15)",borderRadius:50,fontSize:12,fontWeight:600,color:C.green}}>{PHASES.filter(p=>p.done).length} phases done</span>
                  <span style={{padding:"4px 12px",background:"rgba(124,58,237,0.15)",borderRadius:50,fontSize:12,fontWeight:600,color:"#A78BFA"}}>Step 8 · Concept</span>
                </div>
              </div>
              <div style={{display:"flex",flexDirection:"column",gap:5}}>
                {PHASES.map((ph)=>(
                  <div key={ph.num} style={{display:"flex",alignItems:"center",gap:8}}>
                    <div style={{width:20,height:20,borderRadius:6,background:ph.done?ph.color:"#1E1E1E",display:"flex",alignItems:"center",justifyContent:"center",transition:"all 0.3s"}}>
                      {ph.done&&<span style={{color:"#FFF",fontSize:10,fontWeight:700}}>✓</span>}
                    </div>
                    <span style={{fontSize:10,color:ph.done?"#6B5A3A":"#2A2A2A",fontWeight:ph.done?500:400}}>{ph.label}</span>
                  </div>
                ))}
              </div>
            </div>
            <div style={{maxWidth:860,margin:"10px auto 0"}}>
              <div style={{height:2,background:"rgba(255,255,255,0.05)",borderRadius:1}}>
                <div style={{height:"100%",background:"linear-gradient(90deg,#C9922A,#E8B84B)",borderRadius:1,width:pct+"%",transition:"width 0.8s ease"}}/>
              </div>
            </div>
          </div>

          {/* Nav grid */}
          <div style={{maxWidth:860,margin:"0 auto",padding:"24px 28px 40px"}}>
            <p style={{fontSize:10,fontWeight:700,letterSpacing:"0.14em",textTransform:"uppercase",color:"#333",marginBottom:12}}>Open a workspace</p>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:24}}>
              {[
                {id:"concept",emoji:"🎨",label:"Concept Room",sub:"Inspiration · Mood board · Color story · Midjourney · Nano Banana",c:C.purple,step:"Step 8"},
                {id:"board",  emoji:"✦", label:"Phase Board", sub:"Fill in the spec · 7 phases · Closing packet",c:C.gold,step:"Steps 11–16"},
                {id:"client", emoji:"📁",label:"Client File",  sub:"Timeline · Checklists · Documents · Notes",c:C.green,step:"All phases"},
                {id:"logistics",emoji:"📦",label:"Logistics Hub",sub:"Cabinetry · Stone · Tile · Plumbing · Delivery",c:C.teal,step:"Construction"},
              ].map((n,i)=>(
                <button key={n.id} onClick={()=>setScreen(n.id)}
                  style={{display:"flex",alignItems:"center",gap:14,padding:"18px 20px",background:"#171717",border:"1px solid #222",borderRadius:18,cursor:"pointer",textAlign:"left",animation:"fadeUp 0.3s ease "+(i*0.06)+"s both",transition:"all 0.15s",width:"100%"}}
                  onMouseEnter={e=>{e.currentTarget.style.background="#1E1E1E";e.currentTarget.style.borderColor=n.c+"55";}}
                  onMouseLeave={e=>{e.currentTarget.style.background="#171717";e.currentTarget.style.borderColor="#222";}}>
                  <div style={{width:48,height:48,borderRadius:14,background:n.c+"18",display:"flex",alignItems:"center",justifyContent:"center",fontSize:22,flexShrink:0}}>{n.emoji}</div>
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{display:"flex",alignItems:"center",gap:7,marginBottom:4}}>
                      <p style={{fontSize:15,fontWeight:700,color:n.c}}>{n.label}</p>
                      <span style={{padding:"2px 7px",background:n.c+"18",borderRadius:50,fontSize:9,fontWeight:700,color:n.c}}>{n.step}</span>
                    </div>
                    <p style={{fontSize:11,color:"#444",lineHeight:1.5}}>{n.sub}</p>
                  </div>
                  <span style={{fontSize:18,color:n.c+"55"}}>›</span>
                </button>
              ))}
            </div>

            {/* Team + Activity */}
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
              <div style={{background:"#171717",borderRadius:18,overflow:"hidden",border:"1px solid #222"}}>
                <div style={{padding:"14px 18px",borderBottom:"1px solid #1E1E1E"}}>
                  <p style={{fontSize:10,fontWeight:700,color:"#333",textTransform:"uppercase",letterSpacing:"0.12em"}}>Recent Activity</p>
                </div>
                {[
                  {who:"Grace",c:C.purple,action:"Completed Shower Tile",time:"2 min ago"},
                  {who:"Grace",c:C.purple,action:"Pinned bathroom image",time:"14 min ago"},
                  {who:"Kevin",c:C.green,action:"Ordered shower pan",time:"1 hr ago"},
                  {who:"Erin",c:C.gold,action:"Reviewed stone quote",time:"Yesterday"},
                ].map((a,i,arr)=>(
                  <div key={i} style={{display:"flex",alignItems:"center",gap:10,padding:"11px 18px",borderBottom:i<arr.length-1?"1px solid #1A1A1A":"none"}}>
                    <div style={{width:26,height:26,borderRadius:7,background:a.c+"18",display:"flex",alignItems:"center",justifyContent:"center",fontSize:10,fontWeight:700,color:a.c,flexShrink:0}}>{a.who[0]}</div>
                    <p style={{flex:1,fontSize:12,color:"#888"}}><span style={{color:a.c,fontWeight:600}}>{a.who}</span> {a.action}</p>
                    <p style={{fontSize:10,color:"#333"}}>{a.time}</p>
                  </div>
                ))}
              </div>
              <div style={{background:"#171717",borderRadius:18,overflow:"hidden",border:"1px solid #222"}}>
                <div style={{padding:"14px 18px",borderBottom:"1px solid #1E1E1E"}}>
                  <p style={{fontSize:10,fontWeight:700,color:"#333",textTransform:"uppercase",letterSpacing:"0.12em"}}>Team</p>
                </div>
                {[
                  {name:"Grace",role:"Designer",c:C.purple,online:true,last:"Working on shower glass note"},
                  {name:"Trina",role:"Junior Designer",c:"#DB2777",online:true,last:"Reviewing tile selections"},
                  {name:"Jane",role:"Cabinetry Designer & Chief Architect",c:"#7C3AED",online:false,last:"Updating concept moodboard"},
                  {name:"Kevin",role:"Material Specialist",c:C.green,online:true,last:"Ordered shower pan from DPD"},
                  {name:"Erin",role:"Construction Coordinator",c:C.gold,online:true,last:"Reviewing project timeline"},
                  {name:"Eric",role:"Estimator",c:"#1A4ED8",online:false,last:"Preparing budget for 4530 Via Clarice"},
                  {name:"Ricardo",role:"Head of Construction",c:"#0E7490",online:true,last:"Site visit 1055 Roble Ln"},
                  {name:"Chris",role:"Estimator & Quality Control",c:"#B45309",online:false,last:"Reviewed design package"},
                ].map((m,i,arr)=>(
                  <div key={m.name} style={{display:"flex",alignItems:"center",gap:10,padding:"13px 18px",borderBottom:i<arr.length-1?"1px solid #1A1A1A":"none"}}>
                    <div style={{position:"relative",flexShrink:0}}>
                      <div style={{width:32,height:32,borderRadius:9,background:m.c+"18",display:"flex",alignItems:"center",justifyContent:"center",fontSize:12,fontWeight:700,color:m.c}}>{m.name[0]}</div>
                      <div style={{position:"absolute",bottom:-1,right:-1,width:9,height:9,borderRadius:"50%",background:m.online?C.green:"#2A2A2A",border:"1.5px solid #171717"}}/>
                    </div>
                    <div style={{flex:1,minWidth:0}}>
                      <p style={{fontSize:13,fontWeight:600,color:"#BBB"}}>{m.name} <span style={{fontSize:11,fontWeight:400,color:m.c}}>{m.role}</span></p>
                      <p style={{fontSize:11,color:"#333",overflow:"hidden",whiteSpace:"nowrap",textOverflow:"ellipsis"}}>{m.last}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ── CONCEPT ROOM ── */}
      {screen==="concept"&&(
        <div style={{flex:1,overflow:"auto",background:C.beige,animation:"fadeIn 0.3s ease"}}>
          <div style={{background:"#1A1A1A",borderBottom:"1px solid #111",padding:"0 28px"}}>
            <div style={{maxWidth:860,margin:"0 auto",display:"flex",alignItems:"center",gap:0,height:44,overflowX:"auto"}}>
              {[
                {n:1,l:"Home Consultation",client:true},
                {n:2,l:"Creative Review"},
                {n:3,l:"Pre-Budget Meeting"},
                {n:4,l:"Budget Appointment",client:true},
                {n:5,l:"Internal Ideas Session"},
                {n:6,l:"Onsite Visit",client:true},
                {n:7,l:"Appliance Meeting",client:true},
                {n:8,l:"Concept Development",current:true},
                {n:9,l:"Concept Client Meeting",client:true},
                {n:10,l:"Revisions (1)"},
                {n:11,l:"Design Development"},
                {n:12,l:"Cabinetry Meeting",client:true},
                {n:13,l:"Material Client Meeting",client:true},
                {n:14,l:"Revisions (2)"},
                {n:15,l:"Blue Tape",client:true},
                {n:16,l:"Create Design Package"},
                {n:17,l:"Internal Handoff"},
                {n:18,l:"Client Presentation",client:true},
                {n:19,l:"Revisions (4)"},
                {n:20,l:"Preclosing Meeting"},
                {n:21,l:"Closing Meeting",client:true},
              ].map((s,i)=>(
                <div key={s.n} style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:"0 8px",height:"100%",borderBottom:"2px solid "+(s.current?C.gold:s.n===9?"#7C3AED":"transparent"),minWidth:s.current?110:64,flexShrink:0}}>
                  <div style={{display:"flex",alignItems:"center",gap:2}}>
                    <span style={{fontSize:9,fontWeight:700,color:s.current?C.gold:s.n<8?"#3A3A3A":s.n===9?"#7C5FBB":"#222"}}>{s.n}</span>
                    {s.client&&<div style={{width:4,height:4,borderRadius:"50%",background:"#7C3AED",marginLeft:1}}/>}
                  </div>
                  <span style={{fontSize:7,color:s.current?C.goldLight:s.n<8?"#2A2A2A":s.n===9?"#6B4FA8":"#1A1A1A",fontWeight:s.current?600:400,textAlign:"center",lineHeight:1.2,maxWidth:60}}>{s.l}</span>
                </div>
              ))}
            </div>
          </div>
          <div style={{maxWidth:860,margin:"0 auto",padding:"24px 28px"}}>
            <div style={{display:"grid",gridTemplateColumns:"1fr 280px",gap:20}}>
              {/* Main */}
              <div>
                <h2 style={{fontFamily:"'Cormorant Garamond',serif",fontSize:28,fontWeight:300,color:C.black,marginBottom:4}}>Concept Room</h2>
                <p style={{fontSize:13,color:C.muted,marginBottom:20}}>Step 8 — Primary Bath — Build your concept before the client meeting</p>
                {/* Tabs */}
                <div style={{display:"flex",gap:0,borderBottom:"2px solid "+C.sep,marginBottom:20}}>
                  {["🖼  Inspiration Wall","🎨  Color Story","📝  Notes","🔗  Boards","✦  AI Tools"].map((t,i)=>(
                    <button key={t} style={{padding:"12px 16px",background:"transparent",border:"none",borderBottom:i===0?"3px solid "+C.gold:"3px solid transparent",marginBottom:-2,color:i===0?C.gold:C.muted,fontSize:13,fontWeight:i===0?700:400,cursor:"pointer"}}>{t}</button>
                  ))}
                </div>
                {/* Inspiration grid */}
                <div style={{columns:"160px",columnGap:10}}>
                  {[
                    {url:"https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?w=400&q=80",tag:"Bathroom",pinned:true},
                    {url:"https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=400&q=80",tag:"Tile",pinned:true},
                    {url:"https://images.unsplash.com/photo-1616594039964-ae9021a400a0?w=400&q=80",tag:"Vanity",pinned:false},
                    {url:"https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=400&q=80",tag:"Bathroom",pinned:true},
                    {url:"https://images.unsplash.com/photo-1600585154526-990dced4db0d?w=400&q=80",tag:"Kitchen",pinned:false},
                    {url:"https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=400&q=80",tag:"Kitchen",pinned:false},
                  ].map((img,i)=>(
                    <div key={i} style={{breakInside:"avoid",marginBottom:10,borderRadius:12,overflow:"hidden",position:"relative",boxShadow:img.pinned?"0 0 0 3px "+C.gold+",0 4px 14px rgba(0,0,0,0.12)":"0 2px 8px rgba(0,0,0,0.08)",animation:"fadeUp 0.3s ease "+(i*0.05)+"s both"}}>
                      <img src={img.url} alt="" style={{width:"100%",display:"block"}} onError={e=>e.target.parentElement.style.display="none"}/>
                      <div style={{position:"absolute",top:6,left:6,padding:"2px 8px",background:"rgba(0,0,0,0.5)",borderRadius:50,fontSize:9,fontWeight:600,color:"#FFF"}}>{img.tag}</div>
                      {img.pinned&&<div style={{position:"absolute",top:6,right:6,width:22,height:22,borderRadius:"50%",background:C.gold,display:"flex",alignItems:"center",justifyContent:"center",fontSize:11}}>📌</div>}
                    </div>
                  ))}
                </div>
                {/* AI tools preview */}
                <div style={{marginTop:16,display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
                  {[
                    {emoji:"✦",label:"Midjourney",sub:"Concept mood & inspiration",c:"#5865F2",url:"https://www.midjourney.com"},
                    {emoji:"🍌",label:"Nano Banana Pro",sub:"Photorealistic material renders",c:C.gold,url:"https://gemini.google.com/app"},
                  ].map(t=>(
                    <div key={t.label} style={{background:"#FFF",borderRadius:14,overflow:"hidden",border:"1.5px solid "+C.sep}}>
                      <div style={{padding:"12px 14px",background:t.c==="5865F2"?"#0F0F1A":"#1A1100",display:"flex",alignItems:"center",gap:10}}>
                        <span style={{fontSize:18}}>{t.emoji}</span>
                        <div><p style={{fontSize:13,fontWeight:700,color:"#F5EDD8"}}>{t.label}</p><p style={{fontSize:10,color:"#555"}}>{t.sub}</p></div>
                      </div>
                      <div style={{padding:"10px 14px",display:"flex",gap:8}}>
                        <button style={{flex:1,padding:"8px",background:C.beige,border:"1.5px solid "+C.sep,borderRadius:9,fontSize:11,fontWeight:600,color:C.muted,cursor:"pointer"}}>📋 Copy Prompt</button>
                        <a href={t.url} target="_blank" rel="noreferrer" style={{flex:1,padding:"8px",background:t.c,border:"none",borderRadius:9,color:"#FFF",fontSize:11,fontWeight:700,cursor:"pointer",textDecoration:"none",textAlign:"center",display:"flex",alignItems:"center",justifyContent:"center"}}>Open →</a>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              {/* Right sidebar */}
              <div>
                <div style={{background:C.black,borderRadius:18,overflow:"hidden",marginBottom:12}}>
                  <div style={{padding:"16px 18px",borderBottom:"1px solid #1A1A1A"}}>
                    <p style={{fontSize:10,fontWeight:700,letterSpacing:"0.14em",color:"#444",textTransform:"uppercase",marginBottom:4}}>Concept Summary</p>
                    <p style={{fontFamily:"'Cormorant Garamond',serif",fontSize:18,fontWeight:300,color:"#F5EDD8"}}>Primary Bath</p>
                    <p style={{fontSize:11,color:"#3A3A3A"}}>Step 8 — Concept Development</p>
                  </div>
                  <div style={{padding:"16px 18px"}}>
                    <p style={{fontSize:10,fontWeight:700,color:"#444",textTransform:"uppercase",letterSpacing:"0.08em",marginBottom:10}}>Ready for Step 9?</p>
                    <div style={{height:4,background:"#1A1A1A",borderRadius:2,marginBottom:14}}>
                      <div style={{height:"100%",background:C.gold,borderRadius:2,width:"80%"}}/>
                    </div>
                    {["3+ images pinned","Color palette defined","Style direction set","Concept notes written","Reference boards linked"].map((item,i)=>(
                      <div key={item} style={{display:"flex",alignItems:"center",gap:8,marginBottom:8}}>
                        <div style={{width:16,height:16,borderRadius:5,background:i<3?C.gold:"#1A1A1A",border:"1.5px solid "+(i<3?C.gold:"#2A2A2A"),display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                          {i<3&&<span style={{color:"#000",fontSize:9,fontWeight:700}}>v</span>}
                        </div>
                        <p style={{fontSize:11,color:i<3?"#888":"#333"}}>{item}</p>
                      </div>
                    ))}
                  </div>
                  <div style={{padding:"0 16px 16px"}}>
                    <button style={{width:"100%",padding:"13px",background:"linear-gradient(135deg,#0F0F0F,#2C2C2C)",border:"2px solid "+C.gold,borderRadius:12,color:C.gold,fontSize:13,fontWeight:700,cursor:"pointer"}}>Ready for Step 9 →</button>
                  </div>
                </div>
                <div style={{background:C.white,borderRadius:14,overflow:"hidden",border:"1.5px solid "+C.sep}}>
                  <div style={{padding:"12px 16px",background:C.beigeDeep,borderBottom:"1px solid "+C.sep}}>
                    <p style={{fontSize:10,fontWeight:700,color:C.muted,textTransform:"uppercase",letterSpacing:"0.08em"}}>Pinned (4)</p>
                  </div>
                  <div style={{padding:"12px 14px",display:"grid",gridTemplateColumns:"1fr 1fr",gap:6}}>
                    {[
                      "https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?w=200&q=70",
                      "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=200&q=70",
                      "https://images.unsplash.com/photo-1507652313519-d4e9174996dd?w=200&q=70",
                      "https://images.unsplash.com/photo-1600585154526-990dced4db0d?w=200&q=70",
                    ].map((url,i)=>(
                      <div key={i} style={{height:52,borderRadius:8,overflow:"hidden",background:C.beigeDeep}}>
                        <img src={url} style={{width:"100%",height:"100%",objectFit:"cover"}} onError={e=>e.target.style.display="none"}/>
                      </div>
                    ))}
                  </div>
                  <div style={{padding:"0 14px 12px"}}>
                    <div style={{height:24,borderRadius:7,overflow:"hidden",display:"flex"}}>
                      {["#F5F0E8","#C9922A","#2C2C2C","#8B7355"].map(c=><div key={c} style={{flex:1,background:c}}/>)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ── PHASE BOARD ── */}
      {screen==="board"&&(
        <div style={{flex:1,overflow:"auto",background:C.beige,animation:"fadeIn 0.3s ease"}}>
          {/* Section panel */}
          {activeSection&&(
            <div style={{position:"fixed",top:52,right:0,bottom:0,width:320,background:"#FDF6EE",borderLeft:"2px solid #F0D8A8",zIndex:50,overflow:"auto",animation:"fadeIn 0.2s ease",display:"flex",flexDirection:"column",boxShadow:"-8px 0 32px rgba(0,0,0,0.1)"}}>
              <div style={{padding:"18px 20px",background:C.gold,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <div>
                  <p style={{fontSize:10,fontWeight:700,color:"rgba(255,255,255,0.6)",textTransform:"uppercase",letterSpacing:"0.1em",marginBottom:2}}>Section</p>
                  <p style={{fontSize:17,fontWeight:700,color:"#FFF"}}>{activeSection.label}</p>
                </div>
                <button onClick={()=>setActiveSection(null)} style={{width:30,height:30,borderRadius:"50%",background:"rgba(255,255,255,0.15)",border:"none",color:"#FFF",fontSize:16,cursor:"pointer"}}>×</button>
              </div>
              <div style={{flex:1,padding:"20px"}}>
                {(completedSections[activeSection.label]||activeSection.status==="done")?(
                  <div>
                    <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:14}}>
                      <div style={{width:28,height:28,borderRadius:"50%",background:C.green,display:"flex",alignItems:"center",justifyContent:"center"}}><span style={{color:"#FFF",fontSize:14,fontWeight:700}}>✓</span></div>
                      <p style={{fontSize:14,fontWeight:700,color:C.green}}>Complete</p>
                    </div>
                    {activeSection.note&&<p style={{fontSize:14,color:C.muted,lineHeight:1.7,padding:"14px",background:"#FFF",borderRadius:12,border:"1.5px solid #F0D8A8"}}>{activeSection.note}</p>}
                  </div>
                ):(
                  <div>
                    <p style={{fontSize:14,color:C.muted,marginBottom:16,lineHeight:1.6}}>{activeSection.note||"Fill in this section to complete it."}</p>
                    {activeSection.status==="blocked"&&<div style={{padding:"12px 14px",background:"#FDECEB",borderRadius:12,marginBottom:14,border:"1.5px solid rgba(192,23,15,0.2)"}}><p style={{fontSize:13,color:"#C0170F",fontWeight:600}}>Blocked — resolve before release</p></div>}
                    {activeSection.status==="review"&&<div style={{padding:"12px 14px",background:"#FEF3C7",borderRadius:12,marginBottom:14,border:"1.5px solid rgba(180,83,9,0.2)"}}><p style={{fontSize:13,color:"#B45309",fontWeight:600}}>Needs review before release</p></div>}
                    <button onClick={()=>markDone(activeSection.label)} style={{width:"100%",padding:"15px",background:C.gold,border:"none",borderRadius:13,color:"#FFF",fontSize:15,fontWeight:700,cursor:"pointer",boxShadow:"0 4px 14px rgba(201,146,42,0.4)"}}>Mark as Complete ✓</button>
                  </div>
                )}
                <div style={{marginTop:16,borderTop:"1px solid #F0D8A8",paddingTop:14}}>
                  <p style={{fontSize:10,fontWeight:700,color:C.muted,textTransform:"uppercase",letterSpacing:"0.08em",marginBottom:8}}>External Tools</p>
                  <a href="https://app.rayon.design" target="_blank" rel="noreferrer" style={{display:"flex",alignItems:"center",gap:8,padding:"10px 12px",background:"#FFF",borderRadius:10,border:"1.5px solid #F0D8A8",textDecoration:"none",marginBottom:7}}>
                    <span>📐</span><div><p style={{fontSize:12,fontWeight:700,color:C.text}}>Open in Rayon</p><p style={{fontSize:10,color:C.muted}}>Floor plans & elevations</p></div>
                  </a>
                  <button onClick={()=>setScreen("concept")} style={{width:"100%",display:"flex",alignItems:"center",gap:8,padding:"10px 12px",background:"#FFF",borderRadius:10,border:"1.5px solid #F0D8A8",cursor:"pointer",textAlign:"left"}}>
                    <span>✦</span><div><p style={{fontSize:12,fontWeight:700,color:C.text}}>AI Visualizer</p><p style={{fontSize:10,color:C.muted}}>Midjourney & Nano Banana</p></div>
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Top bar */}
          <div style={{background:"#FFF",borderBottom:"1px solid "+C.sep,padding:"12px 28px",display:"flex",alignItems:"center",gap:20,position:"sticky",top:52,zIndex:40}}>
            <div style={{display:"flex",alignItems:"center",gap:12}}>
              <div style={{position:"relative",width:40,height:40}}>
                <svg width={40} height={40} style={{transform:"rotate(-90deg)"}}>
                  <circle cx={20} cy={20} r={14} fill="none" stroke={C.sep} strokeWidth={5}/>
                  <circle cx={20} cy={20} r={14} fill="none" stroke={C.gold} strokeWidth={5} strokeDasharray={88} strokeDashoffset={88-(pct/100)*88} strokeLinecap="round"/>
                </svg>
                <div style={{position:"absolute",inset:0,display:"flex",alignItems:"center",justifyContent:"center"}}><span style={{fontSize:9,fontWeight:700,color:C.gold}}>{pct}%</span></div>
              </div>
              <div><p style={{fontSize:14,fontWeight:700}}>1055 Roble Ln — Primary Bath</p><p style={{fontSize:11,color:C.muted}}>{doneSections}/{SECTIONS.length} sections · {PHASES.filter(p=>p.done).length} phases done</p></div>
            </div>
            <div style={{flex:1,height:3,background:C.sep,borderRadius:2}}>
              <div style={{height:"100%",background:"linear-gradient(90deg,"+C.gold+","+C.goldLight+")",borderRadius:2,width:pct+"%",transition:"width 0.6s ease"}}/>
            </div>
            <button style={{padding:"9px 20px",background:"linear-gradient(135deg,#C9922A,#8B5E2A)",border:"none",borderRadius:50,color:"#FFF",fontSize:12,fontWeight:700,cursor:"pointer"}}>Generate Packet →</button>
          </div>

          <div style={{maxWidth:900,margin:"0 auto",padding:"24px 28px 60px"}}>
            {PHASES.map((phase,pi)=>{
              const pColors=["#C9922A","#1A4ED8","#0E7490","#B45309","#6B21A8","#1A7A3C","#9D174D"];
              const pSofts=["#FDF3E3","#EBF0FD","#E0F7FA","#FEF3C7","#F3EAFD","#EBF7EF","#FCE7F3"];
              const acc=pColors[pi];
              const phaseSections=SECTIONS.filter((s,i)=>Math.floor(i/1.15)===pi||pi===1&&i<4||pi===0&&i>=4&&i<5||pi===2&&i===5||pi===3&&i===6||pi===6&&i===7);
              const realSections=pi===0?[SECTIONS[7]]:pi===1?SECTIONS.slice(0,2):pi===2?[SECTIONS[2]]:pi===3?[SECTIONS[3]]:pi===4?[SECTIONS[4]]:pi===5?[SECTIONS[5]]:pi===6?[SECTIONS[6]]:[];
              const allDone=realSections.every(s=>completedSections[s.label]||s.status==="done");
              return(
                <div key={phase.num} style={{marginBottom:24,animation:"fadeUp 0.4s ease "+(pi*0.05)+"s both"}}>
                  <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:12}}>
                    <div style={{width:36,height:36,borderRadius:11,background:allDone?acc:"#FFF",border:"2px solid "+(allDone?acc:C.sep),display:"flex",alignItems:"center",justifyContent:"center",fontSize:16,transition:"all 0.3s"}}>
                      {allDone?<span style={{color:"#FFF",fontSize:14,fontWeight:700}}>✓</span>:<span>{phase.icon}</span>}
                    </div>
                    <div style={{flex:1}}>
                      <p style={{fontSize:10,fontWeight:700,color:acc,textTransform:"uppercase",letterSpacing:"0.1em",marginBottom:1}}>Phase {phase.num}</p>
                      <p style={{fontSize:16,fontWeight:700,color:C.text}}>{phase.label}</p>
                    </div>
                  </div>
                  <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(200px,1fr))",gap:8,paddingLeft:48}}>
                    {realSections.map(sec=>{
                      const done=completedSections[sec.label]||sec.status==="done";
                      const isActive=activeSection?.label===sec.label;
                      return(
                        <div key={sec.label} onClick={()=>setActiveSection(sec)}
                          style={{background:done?pSofts[pi]:"#FFF",border:"2px solid "+(isActive?acc:done?acc+"44":sec.status==="blocked"?"#FDECEB":C.sep),borderStyle:sec.status==="empty"?"dashed":"solid",borderRadius:14,padding:"14px",cursor:"pointer",transition:"all 0.18s",position:"relative",overflow:"hidden"}}
                          onMouseEnter={e=>{e.currentTarget.style.transform="translateY(-2px)";e.currentTarget.style.boxShadow="0 6px 18px rgba(0,0,0,0.1)";}}
                          onMouseLeave={e=>{e.currentTarget.style.transform="translateY(0)";e.currentTarget.style.boxShadow="none";}}>
                          <div style={{position:"absolute",top:0,left:0,right:0,height:3,background:"#F0EBE0"}}>
                            <div style={{height:"100%",background:done?acc:sec.status==="review"?"#F59E0B":"#E8E0D0",width:done?"100%":sec.status==="review"?"60%":"0%",transition:"width 0.6s"}}/>
                          </div>
                          <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:6,marginTop:4}}>
                            <p style={{fontSize:13,fontWeight:700,color:done?acc:sec.status==="empty"?C.muted:C.text,lineHeight:1.3}}>{sec.label}</p>
                            {done&&<div style={{width:20,height:20,borderRadius:"50%",background:acc,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,animation:"checkIn 0.4s ease"}}><span style={{color:"#FFF",fontSize:10,fontWeight:700}}>✓</span></div>}
                            {sec.status==="review"&&!done&&<span style={{padding:"2px 7px",background:"#FEF3C7",borderRadius:50,fontSize:9,fontWeight:700,color:"#B45309"}}>Review</span>}
                            {sec.status==="blocked"&&<span style={{padding:"2px 7px",background:"#FDECEB",borderRadius:50,fontSize:9,fontWeight:700,color:"#C0170F"}}>Blocked</span>}
                          </div>
                          {sec.note&&done&&<p style={{fontSize:11,color:C.muted,lineHeight:1.4}}>{sec.note}</p>}
                          {sec.status==="empty"&&<p style={{fontSize:11,color:"#C0B4A4",fontStyle:"italic"}}>Tap to fill in</p>}
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* ── CLIENT FILE ── */}
      {screen==="client"&&(
        <div style={{flex:1,overflow:"auto",background:C.beige,animation:"fadeIn 0.3s ease"}}>
          <div style={{background:"#0A1428",padding:"24px 32px"}}>
            <div style={{maxWidth:860,margin:"0 auto",display:"flex",gap:20}}>
              {[{l:"Construction",v:"79%",c:C.gold},{l:"Checklists",v:Math.round(Object.values(checks).filter(Boolean).length/CHECKS.length*100)+"%",c:C.blue},{l:"Milestones",v:MILESTONES.filter(m=>m.done).length+"/"+MILESTONES.length,c:C.green}].map(s=>(
                <div key={s.l} style={{flex:1,background:"rgba(255,255,255,0.06)",borderRadius:14,padding:"14px 18px",textAlign:"center"}}>
                  <p style={{fontSize:22,fontWeight:700,color:s.c,marginBottom:2}}>{s.v}</p>
                  <p style={{fontSize:11,color:"#2A4A7F"}}>{s.l}</p>
                </div>
              ))}
            </div>
          </div>
          <div style={{maxWidth:860,margin:"0 auto",padding:"24px 28px 40px",display:"grid",gridTemplateColumns:"1fr 1fr",gap:16}}>
            {/* Client info */}
            <div style={{background:"#FFF",borderRadius:18,overflow:"hidden",boxShadow:"0 2px 10px rgba(0,0,0,0.06)"}}>
              <div style={{padding:"14px 18px",background:C.black}}><p style={{fontSize:10,fontWeight:700,color:C.gold,textTransform:"uppercase",letterSpacing:"0.1em"}}>Client Information</p></div>
              {[["Client","Ray Hahn & Will Long"],["Phone","415-412-2681"],["Address","1055 Roble Ln, SB CA"],["Contract","Oct 28, 2025"],["Budget","$170,224"],["PM","Erin · 805-770-0059"]].map(([l,v],i,a)=>(
                <div key={l} style={{display:"grid",gridTemplateColumns:"90px 1fr",gap:8,padding:"10px 18px",borderBottom:i<a.length-1?"1px solid "+C.sep:"none",alignItems:"start"}}>
                  <p style={{fontSize:10,fontWeight:700,color:C.muted,textTransform:"uppercase",letterSpacing:"0.04em"}}>{l}</p>
                  <p style={{fontSize:13,color:C.text}}>{v}</p>
                </div>
              ))}
            </div>
            {/* Timeline */}
            <div style={{background:"#FFF",borderRadius:18,overflow:"hidden",boxShadow:"0 2px 10px rgba(0,0,0,0.06)"}}>
              <div style={{padding:"14px 18px",background:C.black}}><p style={{fontSize:10,fontWeight:700,color:C.gold,textTransform:"uppercase",letterSpacing:"0.1em"}}>Timeline</p></div>
              <div style={{maxHeight:260,overflow:"auto"}}>
                {MILESTONES.map((m,i)=>(
                  <div key={m.l} style={{display:"flex",gap:10,padding:"10px 18px",borderBottom:i<MILESTONES.length-1?"1px solid "+C.sep:"none",alignItems:"center",background:m.done?"#F0FDF4":"#FFF"}}>
                    <div style={{width:20,height:20,borderRadius:"50%",background:m.done?C.green:C.sep,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                      {m.done&&<span style={{color:"#FFF",fontSize:10,fontWeight:700}}>✓</span>}
                    </div>
                    <p style={{flex:1,fontSize:12,fontWeight:m.done?600:400,color:m.done?C.text:C.muted}}>{m.l}</p>
                    <p style={{fontSize:10,color:m.done?C.green:C.muted,fontWeight:m.done?600:400}}>{m.d}</p>
                  </div>
                ))}
              </div>
            </div>
            {/* Checklist */}
            <div style={{background:"#FFF",borderRadius:18,overflow:"hidden",boxShadow:"0 2px 10px rgba(0,0,0,0.06)",gridColumn:"1/-1"}}>
              <div style={{padding:"14px 18px",background:C.black,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <p style={{fontSize:10,fontWeight:700,color:C.gold,textTransform:"uppercase",letterSpacing:"0.1em"}}>During Construction Checklist</p>
                <p style={{fontSize:11,color:C.gold,fontWeight:600}}>{Object.values(checks).filter(Boolean).length}/{CHECKS.length} done</p>
              </div>
              <div style={{height:3,background:C.sep}}><div style={{height:"100%",background:C.green,width:(Object.values(checks).filter(Boolean).length/CHECKS.length*100)+"%",transition:"width 0.3s"}}/></div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr"}}>
                {CHECKS.map((item,i)=>(
                  <div key={item} style={{display:"flex",alignItems:"center",gap:10,padding:"12px 18px",borderBottom:i<CHECKS.length-2?"1px solid "+C.sep:"none",borderRight:i%2===0?"1px solid "+C.sep:"none",cursor:"pointer",background:checks[item]?"#F0FDF4":"#FFF"}}
                    onClick={()=>setChecks(p=>({...p,[item]:!p[item]}))}>
                    <div style={{width:22,height:22,borderRadius:7,background:checks[item]?C.green:C.beige,border:"1.5px solid "+(checks[item]?C.green:C.sep),display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,transition:"all 0.15s"}}>
                      {checks[item]&&<span style={{color:"#FFF",fontSize:12,fontWeight:700}}>✓</span>}
                    </div>
                    <p style={{fontSize:13,color:checks[item]?"#94A3B8":C.text,textDecoration:checks[item]?"line-through":"none"}}>{item}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Logistics placeholder */}
      {screen==="logistics"&&(
        <div style={{flex:1,overflow:"auto",background:"#111",padding:"28px",animation:"fadeIn 0.3s ease"}}>
          <div style={{maxWidth:760,margin:"0 auto"}}>
            <h2 style={{fontFamily:"'Cormorant Garamond',serif",fontSize:32,fontWeight:300,color:"#F5EDD8",marginBottom:4}}>Logistics Hub</h2>
            <p style={{fontSize:13,color:"#444",marginBottom:24}}>Material receiving and delivery — 1055 Roble Ln</p>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}>
              {[
                {e:"🪵",l:"Cabinetry",s:"2 orders · 22 boxes · Box inspection",c:C.gold,pct:65},
                {e:"◈",l:"Stone",s:"Quartz + Quartzite · Duarte template Apr 4",c:C.purple,pct:40},
                {e:"✦",l:"Miscellaneous",s:"12 items · Door hardware · Sealers",c:C.muted,pct:58},
                {e:"⬡",l:"Tile",s:"85 SF shower · 65 SF floor · At showroom",c:C.blue,pct:90},
                {e:"▦",l:"Flooring",s:"Hardwood · LVP · Carpet · Not yet arrived",c:C.teal,pct:20},
                {e:"🚿",l:"Plumbing Fixtures",s:"4 orders · 20 fixtures · All arrived",c:C.green,pct:100},
              ].map((cat,i)=>(
                <div key={cat.l} style={{background:"#1A1A1A",borderRadius:18,padding:"18px 20px",border:"1px solid #222",animation:"fadeUp 0.4s ease "+(i*0.06)+"s both",cursor:"pointer",transition:"all 0.15s"}}
                  onMouseEnter={e=>{e.currentTarget.style.background="#202020";e.currentTarget.style.borderColor=cat.c+"44";}}
                  onMouseLeave={e=>{e.currentTarget.style.background="#1A1A1A";e.currentTarget.style.borderColor="#222";}}>
                  <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:12}}>
                    <div style={{width:42,height:42,borderRadius:13,background:cat.c+"18",display:"flex",alignItems:"center",justifyContent:"center",fontSize:20}}>{cat.e}</div>
                    <div style={{flex:1}}>
                      <p style={{fontSize:15,fontWeight:700,color:cat.c,marginBottom:2}}>{cat.l}</p>
                      <p style={{fontSize:11,color:"#3A3A3A"}}>{cat.s}</p>
                    </div>
                    <span style={{fontSize:15,fontWeight:700,color:cat.c}}>{cat.pct}%</span>
                  </div>
                  <div style={{height:4,background:"#222",borderRadius:2}}>
                    <div style={{height:"100%",background:cat.c,borderRadius:2,width:cat.pct+"%",transition:"width 0.8s ease"}}/>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Bottom nav */}
      <div style={{background:"#0A0A0A",borderTop:"1px solid #1A1A1A",height:52,display:"flex",alignItems:"center",justifyContent:"center",gap:4,flexShrink:0}}>
        {Object.entries(SCREENS).map(([id,label])=>(
          <button key={id} onClick={()=>{setScreen(id);setActiveSection(null);}}
            style={{padding:"8px 16px",background:screen===id?"rgba(201,146,42,0.12)":"transparent",border:"none",borderRadius:50,color:screen===id?C.gold:"#333",fontSize:12,fontWeight:screen===id?700:400,cursor:"pointer",transition:"all 0.15s"}}>
            {label}
          </button>
        ))}
      </div>
    </div>
  );
}
